<template>
  <div class="ds-control mobile dsf_teas_lecture_address_detail">
    <div class="detail_bg"></div>
    <div class="detail_box">
      <div class="box_headerInfor">
        <div class="header">
          <van-image
            class="img"
            round
            width="108"
            height="108"
            :src="dataInfor.photo | headerImg"
          />
        </div>
        <div class="name">
          <div class="name_text">{{ dataInfor.name }}</div>
          <div class="xiao">{{ dataInfor.sourceText }}</div>
        </div>
        <div class="postion">{{ dataInfor.post }}</div>
        <div class="line"></div>
      </div>
      <div class="box_content">
        <div class="box_content_class">
          <div class="text">授课经历</div>
          <div class="class">
            <van-dropdown-menu class="years" active-color="#3C8DDB">
              <van-dropdown-item
                v-model="year.value"
                @change="yearchange"
                :options="yearactions"
              />
            </van-dropdown-menu>
            <div class="classItems">
              <div
                class="class_item"
                :class="
                  activeClass == 'ben'
                    ? 'active_class_item'
                    : 'default_class_item'
                "
                @click="clickClass('ben')"
              >
                本班
              </div>
              <div
                class="class_item"
                :class="
                  activeClass == 'all'
                    ? 'active_class_item'
                    : 'default_class_item'
                "
                @click="clickClass('all')"
              >
                全部
              </div>
            </div>
          </div>
        </div>
        <div class="box_content_list">
          <!-- <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            v-if="list.length > 0"
          > -->
          <van-list
            v-model="loading"
            :finished="finished"
            @load="getList"
            v-if="list.length > 0"
          >
            <div class="list_box">
              <div
                class="list_box_item"
                :class="index == list.length - 1 ? 'last_item' : ''"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="item_time">
                  <div class="circle"></div>
                  <div class="time">{{ item.startDatetime | dealtime}}</div>
                </div>
                <div class="list_box_content">
                  <div class="content">
                    <div class="project_name">
                      <!-- <span class="xuanxiu" v-if="item.electiveValue && item.electiveValue == 1">选修</span> -->
                      <span class="xuanxiu" v-if="item.electiveValue && item.electiveValue == 1">选修</span>{{ item.itemText }}
                    </div>
                    <div class="class_name">
                      {{ item.orgTypeText }}:{{ item.orgText }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <!-- </van-pull-refresh> -->
          <van-empty v-else description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const testData = {};
export default dsf.component({
  name: "DsfMobileTeasLectureAddressBookDetail",
  mixins: [$mixins.control],
  ctrlCaption: "授课老师通讯录详情",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "teas/schedule/course/arrange/findUserTeacherSchedule",
    },
    listUrl: {
      type: String,
      default: "teas/schedule/course/arrange/findTeacherSchedule",
    },
  },
  components: {},
  data() {
    return {
      dataInfor: {},
      activeClass: "ben",
      year: { text: "全部", value: "全部" },
      yearactions: [],
      pageNumber: 0,
      pageSize: "10",
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
    };
  },
  created() {
    if (this.isDesign) {
      this.dataInfor = testData;
    } else {
      this.getyear();
      //获取信息
      this.getInfor();
      this.getList();
    }
  },
  filters: {
    headerImg: function (value) {
      if (value && value.length != 0) {
        var zp = JSON.parse(value);
        var imgObj = zp[0];
        return dsf.url.getWebPath(imgObj.relativePath);
      } else {
        return dsf.config.setting_public_user_default_header;
      }
    },
    dealtime: function(value) {
        if (value && value.length != 0) {
          return value.substring(0,16);
        } else {
          return '';
        }
    },
  },
  methods: {
    yearchange: function () {
      this.onRefresh();
    },
    clickClass: function (type) {
      this.activeClass = type;
      this.onRefresh();
    },
    getyear: function () {
      var date = new Date();
      var currentyear = date.getFullYear();
      for (let index = 0; index < 11; index++) {
        var year = currentyear - index;
        var obj = {
          text: year,
          value: year,
        };
        this.yearactions.push(obj);
      }
      this.yearactions.unshift({ text: "全部", value: "全部" });
    },
    // 获取信息
    getInfor() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/schedule/course/arrange/findUserTeacherSchedule", {
          teacherId: this.queryString.teacherId,
          classId: this.queryString.classId,
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dataInfor = res.data;
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 获取列表数据
    getList(isRefresh = false) {
      this.pageNumber++;
      this.$http
        .get("teas/schedule/course/arrange/findTeacherSchedule", {
          pageNumber: this.pageNumber,
          teacherId: this.queryString.teacherId,
          classId: this.activeClass == "ben" ? this.queryString.classId : "",
          pageSize: this.pageSize,
          year: this.year.value == "全部" ? "" : this.year.value,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list;
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage;
          } else {
            dsf.layer.message(res.message, false);
            this.finished = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.finished = true;
        })
        .always(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    // 刷新
    onRefresh() {
      this.pageNumber = 0;
      this.getList(true);
    },
  },
});
</script>